import React, { Fragment, useState } from 'react'
import { Box, Button, Tooltip, Typography } from '@mui/material'
import ListAltIcon from '@mui/icons-material/ListAlt'
import { Modal } from '../../components/_EOS/Modal'

interface ColumnLegend {
  name: string
  description: string
}

// Columnas del archivo .csv exportable del Kardex
const CSV_COLUMNS: ColumnLegend[] = [
  { name: 'Marca', description: 'Cliente del WMS' },
  { name: 'Fecha', description: 'Día del movimiento' },
  { name: 'Hora', description: 'Hora local' },
  { name: 'OT', description: 'Orden de trabajo' },
  { name: 'Nro Documento', description: 'ID orden ASN o Pedido' },
  { name: 'ID Caja / LPN', description: 'Etiqueta del tote o caja' },
  { name: 'Operación', description: 'Tipo de operación logística' },
  { name: 'Dirección', description: 'Entrada / Salida' },
  { name: 'SKU', description: 'Código del producto' },
  { name: 'Descripción', description: 'Nombre del producto' },
  { name: 'Ubicación', description: 'Posición física' },
  { name: 'Tipo Ubicación', description: 'Categoría de la ubicación' },
  { name: 'Lote', description: 'Número de lote si aplica' },
  { name: 'Vencimiento', description: 'Fecha de caducidad FEFO' },
  { name: 'Stock Origen Antes', description: 'Stock en origen antes' },
  { name: 'Cantidad Movida', description: 'Unidades siempre positivo' },
  { name: 'Stock Origen Después', description: 'Stock en origen después' },
  { name: 'Stock Total Almacén', description: 'Total SKU en el almacén' },
  { name: 'Almacén', description: 'Centro de distribución' },
  { name: 'Usuario', description: 'Quien ejecutó la acción' },
  { name: 'Observaciones', description: 'Notas adicionales' }
]

const rowColors = [
  {
    label: '↑ Entrada',
    description: 'Movimiento de ingreso de stock a una ubicación',
    bg: '#eef7ee',
    border: '#4caf50',
    color: '#2e7d32'
  },
  {
    label: '↓ Salida',
    description: 'Movimiento de egreso de stock desde una ubicación',
    bg: '#fdeeee',
    border: '#e53935',
    color: '#c62828'
  },
  {
    label: '— Borrador',
    description: 'Tránsito interno (DRAFT)',
    bg: '#f5f5f5',
    border: '#bdbdbd',
    color: '#616161'
  }
]

const sectionTitleStyle: React.CSSProperties = {
  fontSize: '10px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  color: '#9e9e9e',
  textTransform: 'uppercase',
  marginBottom: '8px'
}

export const KardexLegend: React.FC = () => {
  const [open, setOpen] = useState(false)

  return (
    <Fragment>
      <Tooltip title='Ver leyenda de campos' placement='top'>
        <Button
          variant='outlined'
          color='primary'
          onClick={() => setOpen(true)}
          startIcon={<ListAltIcon />}
          sx={{
            whiteSpace: 'nowrap',
            height: '44px',
            borderRadius: '12px',
            flex: '0 0 auto',
            minWidth: '100px',
            px: 0.8,
            '&:hover': {
              backgroundColor: '#004bb1',
              color: 'white',
              borderColor: '#004bb1'
            }
          }}
        >
          Leyenda
        </Button>
      </Tooltip>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title='Leyenda del Kardex'
        maxWidth='md'
      >
        {/* Colores de fila */}
        <Typography style={sectionTitleStyle}>Colores de fila</Typography>
          <Box
            display='flex'
            style={{ gap: '12px', flexWrap: 'wrap', marginBottom: '10px' }}
          >
            {rowColors.map((item) => (
              <Box
                key={item.label}
                style={{
                  flex: '1 1 200px',
                  backgroundColor: item.bg,
                  borderLeft: `4px solid ${item.border}`,
                  borderRadius: '4px',
                  padding: '8px 12px'
                }}
              >
                <Typography
                  style={{
                    fontSize: '13px',
                    fontWeight: 600,
                    color: item.color,
                    marginBottom: '1px'
                  }}
                >
                  {item.label}
                </Typography>
                <Typography style={{ fontSize: '11px', color: '#666' }}>
                  {item.description}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Columnas del csv */}
          <Typography style={sectionTitleStyle}>
            Columnas del archivo .csv
          </Typography>
          <Box
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '8px 16px'
            }}
          >
            {CSV_COLUMNS.map((col, index) => (
              <Box key={col.name} display='flex' style={{ gap: '8px' }}>
                <Typography
                  style={{
                    fontSize: '12px',
                    fontWeight: 680,
                    color: '#9e9e9e',
                    minWidth: '18px'
                  }}
                >
                  {index + 1}
                </Typography>
                <Box>
                  <Typography style={{ fontSize: '12px', fontWeight: 600 }}>
                    {col.name}
                  </Typography>
                  <Typography style={{ fontSize: '11px', color: '#9e9e9e' }}>
                    {col.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          <Typography
            style={{
              fontSize: '12px',
              color: '#9e9e9e',
              fontStyle: 'italic',
              marginTop: '20px'
            }}
          >
            Los colores aplican solo en pantalla. El archivo .csv no incluye
            formato visual.
          </Typography>
      </Modal>
    </Fragment>
  )
}
